// A tag as the server's filters key it (ItemIndex::tagKey): curly quotes
// straightened, Latin accents folded with the server's own tables
// (FieldKeys::FOLD, then SearchFold::FOLD — not Unicode decomposition, which
// leaves ø, æ or ß alone), combining marks dropped, full-width ASCII as
// ASCII, lower-cased, spacing collapsed, cut at 191 UTF-8 bytes. The item
// page's links put tags in the URL this way, so a link and a ticked box
// write the same value.

const FOLD = {
  'À': 'A', 'Á': 'A', 'Â': 'A', 'Ã': 'A', 'Ä': 'A', 'Å': 'A', 'Ā': 'A', 'Ă': 'A', 'Ą': 'A',
  'à': 'a', 'á': 'a', 'â': 'a', 'ã': 'a', 'ä': 'a', 'å': 'a', 'ā': 'a', 'ă': 'a', 'ą': 'a',
  'Æ': 'AE', 'æ': 'ae', 'Œ': 'OE', 'œ': 'oe', 'ß': 'ss', 'ẞ': 'SS',
  'Ç': 'C', 'Ć': 'C', 'Č': 'C', 'ç': 'c', 'ć': 'c', 'č': 'c',
  'Ď': 'D', 'Đ': 'D', 'Ð': 'D', 'ď': 'd', 'đ': 'd', 'ð': 'd',
  'È': 'E', 'É': 'E', 'Ê': 'E', 'Ë': 'E', 'Ē': 'E', 'Ę': 'E', 'Ě': 'E',
  'è': 'e', 'é': 'e', 'ê': 'e', 'ë': 'e', 'ē': 'e', 'ę': 'e', 'ě': 'e',
  'Ğ': 'G', 'ğ': 'g',
  'Ì': 'I', 'Í': 'I', 'Î': 'I', 'Ï': 'I', 'Ī': 'I', 'İ': 'I',
  'ì': 'i', 'í': 'i', 'î': 'i', 'ï': 'i', 'ī': 'i', 'ı': 'i',
  'Ł': 'L', 'Ľ': 'L', 'ł': 'l', 'ľ': 'l',
  'Ñ': 'N', 'Ń': 'N', 'Ň': 'N', 'ñ': 'n', 'ń': 'n', 'ň': 'n',
  'Ò': 'O', 'Ó': 'O', 'Ô': 'O', 'Õ': 'O', 'Ö': 'O', 'Ø': 'O', 'Ō': 'O', 'Ő': 'O',
  'ò': 'o', 'ó': 'o', 'ô': 'o', 'õ': 'o', 'ö': 'o', 'ø': 'o', 'ō': 'o', 'ő': 'o',
  'Ŕ': 'R', 'Ř': 'R', 'ŕ': 'r', 'ř': 'r',
  'Ś': 'S', 'Š': 'S', 'Ş': 'S', 'Ș': 'S', 'ś': 's', 'š': 's', 'ş': 's', 'ș': 's',
  'Ť': 'T', 'Ţ': 'T', 'Ț': 'T', 'ť': 't', 'ţ': 't', 'ț': 't', 'Þ': 'TH', 'þ': 'th',
  'Ù': 'U', 'Ú': 'U', 'Û': 'U', 'Ü': 'U', 'Ū': 'U', 'Ů': 'U', 'Ű': 'U',
  'ù': 'u', 'ú': 'u', 'û': 'u', 'ü': 'u', 'ū': 'u', 'ů': 'u', 'ű': 'u',
  'Ý': 'Y', 'Ÿ': 'Y', 'ý': 'y', 'ÿ': 'y',
  'Ź': 'Z', 'Ż': 'Z', 'Ž': 'Z', 'ź': 'z', 'ż': 'z', 'ž': 'z',
};
// SearchFold::FOLD: more Latin, Vietnamese, Greek tonos and dialytika, ё.
const SEARCH_FOLD = {
  'Ĉ': 'C', 'ĉ': 'c', 'Ċ': 'C', 'ċ': 'c', 'Ĕ': 'E', 'ĕ': 'e', 'Ė': 'E', 'ė': 'e', 'Ĝ': 'G', 'ĝ': 'g', 'Ġ': 'G', 'ġ': 'g',
  'Ģ': 'G', 'ģ': 'g', 'Ĥ': 'H', 'ĥ': 'h', 'Ĩ': 'I', 'ĩ': 'i', 'Ĭ': 'I', 'ĭ': 'i', 'Į': 'I', 'į': 'i', 'Ĵ': 'J', 'ĵ': 'j',
  'Ķ': 'K', 'ķ': 'k', 'Ĺ': 'L', 'ĺ': 'l', 'Ļ': 'L', 'ļ': 'l', 'Ņ': 'N', 'ņ': 'n', 'Ŏ': 'O', 'ŏ': 'o', 'Ŗ': 'R', 'ŗ': 'r',
  'Ŝ': 'S', 'ŝ': 's', 'Ũ': 'U', 'ũ': 'u', 'Ŭ': 'U', 'ŭ': 'u', 'Ų': 'U', 'ų': 'u', 'Ŵ': 'W', 'ŵ': 'w', 'Ŷ': 'Y', 'ŷ': 'y',
  'Ơ': 'O', 'ơ': 'o', 'Ư': 'U', 'ư': 'u', 'Ǎ': 'A', 'ǎ': 'a', 'Ǐ': 'I', 'ǐ': 'i', 'Ǒ': 'O', 'ǒ': 'o', 'Ǔ': 'U', 'ǔ': 'u',
  'Ǖ': 'U', 'ǖ': 'u', 'Ǘ': 'U', 'ǘ': 'u', 'Ǚ': 'U', 'ǚ': 'u', 'Ǜ': 'U', 'ǜ': 'u', 'Ǟ': 'A', 'ǟ': 'a', 'Ǡ': 'A', 'ǡ': 'a',
  'Ǣ': 'AE', 'ǣ': 'ae', 'Ǧ': 'G', 'ǧ': 'g', 'Ǩ': 'K', 'ǩ': 'k', 'Ǫ': 'O', 'ǫ': 'o', 'Ǭ': 'O', 'ǭ': 'o', 'ǰ': 'j', 'Ǵ': 'G',
  'ǵ': 'g', 'Ǹ': 'N', 'ǹ': 'n', 'Ǻ': 'A', 'ǻ': 'a', 'Ǽ': 'AE', 'ǽ': 'ae', 'Ǿ': 'O', 'ǿ': 'o', 'Ȁ': 'A', 'ȁ': 'a', 'Ȃ': 'A',
  'ȃ': 'a', 'Ȅ': 'E', 'ȅ': 'e', 'Ȇ': 'E', 'ȇ': 'e', 'Ȉ': 'I', 'ȉ': 'i', 'Ȋ': 'I', 'ȋ': 'i', 'Ȍ': 'O', 'ȍ': 'o', 'Ȏ': 'O',
  'ȏ': 'o', 'Ȑ': 'R', 'ȑ': 'r', 'Ȓ': 'R', 'ȓ': 'r', 'Ȕ': 'U', 'ȕ': 'u', 'Ȗ': 'U', 'ȗ': 'u', 'Ȟ': 'H', 'ȟ': 'h', 'Ȧ': 'A',
  'ȧ': 'a', 'Ȩ': 'E', 'ȩ': 'e', 'Ȫ': 'O', 'ȫ': 'o', 'Ȭ': 'O', 'ȭ': 'o', 'Ȯ': 'O', 'ȯ': 'o', 'Ȱ': 'O', 'ȱ': 'o', 'Ȳ': 'Y',
  'ȳ': 'y', 'Ḁ': 'A', 'ḁ': 'a', 'Ḃ': 'B', 'ḃ': 'b', 'Ḅ': 'B', 'ḅ': 'b', 'Ḇ': 'B', 'ḇ': 'b', 'Ḉ': 'C', 'ḉ': 'c', 'Ḋ': 'D',
  'ḋ': 'd', 'Ḍ': 'D', 'ḍ': 'd', 'Ḏ': 'D', 'ḏ': 'd', 'Ḑ': 'D', 'ḑ': 'd', 'Ḓ': 'D', 'ḓ': 'd', 'Ḕ': 'E', 'ḕ': 'e', 'Ḗ': 'E',
  'ḗ': 'e', 'Ḙ': 'E', 'ḙ': 'e', 'Ḛ': 'E', 'ḛ': 'e', 'Ḝ': 'E', 'ḝ': 'e', 'Ḟ': 'F', 'ḟ': 'f', 'Ḡ': 'G', 'ḡ': 'g', 'Ḣ': 'H',
  'ḣ': 'h', 'Ḥ': 'H', 'ḥ': 'h', 'Ḧ': 'H', 'ḧ': 'h', 'Ḩ': 'H', 'ḩ': 'h', 'Ḫ': 'H', 'ḫ': 'h', 'Ḭ': 'I', 'ḭ': 'i', 'Ḯ': 'I',
  'ḯ': 'i', 'Ḱ': 'K', 'ḱ': 'k', 'Ḳ': 'K', 'ḳ': 'k', 'Ḵ': 'K', 'ḵ': 'k', 'Ḷ': 'L', 'ḷ': 'l', 'Ḹ': 'L', 'ḹ': 'l', 'Ḻ': 'L',
  'ḻ': 'l', 'Ḽ': 'L', 'ḽ': 'l', 'Ḿ': 'M', 'ḿ': 'm', 'Ṁ': 'M', 'ṁ': 'm', 'Ṃ': 'M', 'ṃ': 'm', 'Ṅ': 'N', 'ṅ': 'n', 'Ṇ': 'N',
  'ṇ': 'n', 'Ṉ': 'N', 'ṉ': 'n', 'Ṋ': 'N', 'ṋ': 'n', 'Ṍ': 'O', 'ṍ': 'o', 'Ṏ': 'O', 'ṏ': 'o', 'Ṑ': 'O', 'ṑ': 'o', 'Ṓ': 'O',
  'ṓ': 'o', 'Ṕ': 'P', 'ṕ': 'p', 'Ṗ': 'P', 'ṗ': 'p', 'Ṙ': 'R', 'ṙ': 'r', 'Ṛ': 'R', 'ṛ': 'r', 'Ṝ': 'R', 'ṝ': 'r', 'Ṟ': 'R',
  'ṟ': 'r', 'Ṡ': 'S', 'ṡ': 's', 'Ṣ': 'S', 'ṣ': 's', 'Ṥ': 'S', 'ṥ': 's', 'Ṧ': 'S', 'ṧ': 's', 'Ṩ': 'S', 'ṩ': 's', 'Ṫ': 'T',
  'ṫ': 't', 'Ṭ': 'T', 'ṭ': 't', 'Ṯ': 'T', 'ṯ': 't', 'Ṱ': 'T', 'ṱ': 't', 'Ṳ': 'U', 'ṳ': 'u', 'Ṵ': 'U', 'ṵ': 'u', 'Ṷ': 'U',
  'ṷ': 'u', 'Ṹ': 'U', 'ṹ': 'u', 'Ṻ': 'U', 'ṻ': 'u', 'Ṽ': 'V', 'ṽ': 'v', 'Ṿ': 'V', 'ṿ': 'v', 'Ẁ': 'W', 'ẁ': 'w', 'Ẃ': 'W',
  'ẃ': 'w', 'Ẅ': 'W', 'ẅ': 'w', 'Ẇ': 'W', 'ẇ': 'w', 'Ẉ': 'W', 'ẉ': 'w', 'Ẋ': 'X', 'ẋ': 'x', 'Ẍ': 'X', 'ẍ': 'x', 'Ẏ': 'Y',
  'ẏ': 'y', 'Ẑ': 'Z', 'ẑ': 'z', 'Ẓ': 'Z', 'ẓ': 'z', 'Ẕ': 'Z', 'ẕ': 'z', 'ẖ': 'h', 'ẗ': 't', 'ẘ': 'w', 'ẙ': 'y', 'Ạ': 'A',
  'ạ': 'a', 'Ả': 'A', 'ả': 'a', 'Ấ': 'A', 'ấ': 'a', 'Ầ': 'A', 'ầ': 'a', 'Ẩ': 'A', 'ẩ': 'a', 'Ẫ': 'A', 'ẫ': 'a', 'Ậ': 'A',
  'ậ': 'a', 'Ắ': 'A', 'ắ': 'a', 'Ằ': 'A', 'ằ': 'a', 'Ẳ': 'A', 'ẳ': 'a', 'Ẵ': 'A', 'ẵ': 'a', 'Ặ': 'A', 'ặ': 'a', 'Ẹ': 'E',
  'ẹ': 'e', 'Ẻ': 'E', 'ẻ': 'e', 'Ẽ': 'E', 'ẽ': 'e', 'Ế': 'E', 'ế': 'e', 'Ề': 'E', 'ề': 'e', 'Ể': 'E', 'ể': 'e', 'Ễ': 'E',
  'ễ': 'e', 'Ệ': 'E', 'ệ': 'e', 'Ỉ': 'I', 'ỉ': 'i', 'Ị': 'I', 'ị': 'i', 'Ọ': 'O', 'ọ': 'o', 'Ỏ': 'O', 'ỏ': 'o', 'Ố': 'O',
  'ố': 'o', 'Ồ': 'O', 'ồ': 'o', 'Ổ': 'O', 'ổ': 'o', 'Ỗ': 'O', 'ỗ': 'o', 'Ộ': 'O', 'ộ': 'o', 'Ớ': 'O', 'ớ': 'o', 'Ờ': 'O',
  'ờ': 'o', 'Ở': 'O', 'ở': 'o', 'Ỡ': 'O', 'ỡ': 'o', 'Ợ': 'O', 'ợ': 'o', 'Ụ': 'U', 'ụ': 'u', 'Ủ': 'U', 'ủ': 'u', 'Ứ': 'U',
  'ứ': 'u', 'Ừ': 'U', 'ừ': 'u', 'Ử': 'U', 'ử': 'u', 'Ữ': 'U', 'ữ': 'u', 'Ự': 'U', 'ự': 'u', 'Ỳ': 'Y', 'ỳ': 'y', 'Ỵ': 'Y',
  'ỵ': 'y', 'Ỷ': 'Y', 'ỷ': 'y', 'Ỹ': 'Y', 'ỹ': 'y', 'Ά': 'Α', 'Έ': 'Ε', 'Ή': 'Η', 'Ί': 'Ι', 'Ό': 'Ο', 'Ύ': 'Υ', 'Ώ': 'Ω',
  'ΐ': 'ι', 'Ϊ': 'Ι', 'Ϋ': 'Υ', 'ά': 'α', 'έ': 'ε', 'ή': 'η', 'ί': 'ι', 'ΰ': 'υ', 'ϊ': 'ι', 'ϋ': 'υ', 'ό': 'ο', 'ύ': 'υ',
  'ώ': 'ω', 'ϔ': 'ϒ', 'Ё': 'Е', 'ё': 'е', 'Ħ': 'H', 'ħ': 'h', 'Ŧ': 'T', 'ŧ': 't', 'Ŀ': 'L', 'ŀ': 'l', 'ĸ': 'k', 'Ŋ': 'N',
  'ŋ': 'n', 'Ĳ': 'IJ', 'ĳ': 'ij', 'Ɨ': 'I', 'ɨ': 'i', 'Ƶ': 'Z', 'ƶ': 'z', 'Ɖ': 'D', 'ɖ': 'd', 'ƀ': 'b', 'Ƀ': 'B', 'Ǥ': 'G',
  'ǥ': 'g',
};
const QUOTES = { '’': "'", '‘': "'", 'ʼ': "'" };
const SPACES = /[\s  -​  　]+/gu;
export const FACET_VALUE_MAX = 191;

/** Folded, lower-cased, whitespace collapsed and trimmed (ItemIndex::normalize). */
export const normalize = (text) => Array.from(String(text ?? ''))
  .map((ch) => QUOTES[ch] ?? FOLD[ch] ?? ch).join('')
  .split('').map((ch) => SEARCH_FOLD[ch] ?? ch).join('')
  .replace(/\p{Mn}+/gu, '')
  .replace(/[\uFF01-\uFF5E]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 0xFEE0))
  .toLowerCase()
  .replace(SPACES, ' ')
  .trim();

const utf8Length = (codePoint) => (codePoint < 0x80 ? 1 : codePoint < 0x800 ? 2 : codePoint < 0x10000 ? 3 : 4);

/** At most `max` UTF-8 bytes, never half a character (mb_strcut). */
export const cutBytes = (text, max = FACET_VALUE_MAX) => {
  let bytes = 0;
  let out = '';
  for (const ch of text) {
    bytes += utf8Length(ch.codePointAt(0));
    if (bytes > max) break;
    out += ch;
  }
  return out;
};

/** The value of a tag in f.<key>= (ItemIndex::tagKey). */
export const tagKey = (tag) => cutBytes(normalize(tag));
